import React, { useState } from "react";
import Table from "react-bootstrap/Table";
import Header from "../components/header";
import "./pstyle.css";
import translations from "../locals/translation";
import { LuCircleChevronLeft } from "react-icons/lu";
import { IoIosSearch } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { performVerification } from "../commonFunc/verification";

function Reports() {
  const navigate = useNavigate();

  const location = useLocation();
  if (
    location?.state?.mainReports == null ||
    location?.state?.mainReports === undefined
  ) {
    navigate("/dashboard");
  }

  const language = useSelector((state) => state.language.value);

  const t = (key) => {
    if (translations[language]) {
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };

  const [searchInput, setSearchInput] = useState("");
  const [reports, setReports] = useState([]);
  const [statements, setStatements] = useState([]);
  const [loading] = useState(false);
  const [setMess] = useState("");

  const [originalData, setOriginalData] = useState([]);

  async function renderReports() {
    if (location.state == null || location.state === undefined) {
      navigate("/dashboard");
      return;
    }
    const data = location.state.mainReports;
    if (data.status_code === 200) {
    } else if (data.status_code === 404) {
      setMess(data.message);
      return;
    } else {
      Swal.fire(t("Server Error"));
      return;
    }
    setReports(data.data);
    setOriginalData(data.data);
  }
  async function renderStatements() {
    if (location.state == null || location.state === undefined) {
      navigate("/dashboard");
      return;
    }
    const data = location.state.statements;

    if (data.status_code === 200) {
    } else if (data.status_code === 404) {
      Swal.fire(data.message);
      return;
    } else {
      Swal.fire(t("Server Error"));
      return;
    }
    setStatements(data.data);
  }

  useEffect(() => {
    if (!performVerification()) {
      Swal.fire({ text: t("Login first"), icon: "warning" });
      navigate("/login");
    }
    renderReports();
    renderStatements();
    if (
      location?.state?.mainReports == null ||
      location?.state?.mainReports === undefined ||
      location?.state?.mainReports === ""
    ) {
      navigate("/dashboard");
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatDate = (createdAt) => {
    const date = new Date(createdAt);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const formatTime = (createdAt) => {
    const date = new Date(createdAt);
    const options = {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    };
    return date.toLocaleTimeString("en-US", options);
  };

  const handleSearchChange = (e) => {
    let data3 = originalData;
    const inputValue = e.target.value.toLowerCase();
    if (inputValue === "") {
      setReports(originalData);
      setSearchInput("");
      return;
    }
    // Filter the data based on all three fields
    const result = data3.filter((item) =>
      Object.keys(item).some((key) => {
        // Check if the current key is an object
        if (typeof item[key] === "object" && item[key] !== null) {
          // If the key is 'truck', search within its nested fields
          if (key === "truck") {
            return Object.values(item[key]).some(
              (value) =>
                typeof value === "string" &&
                value.toLowerCase().includes(inputValue)
            );
          }
          // If the key is 'vendor' within 'truck', search within its nested fields
          if (key === "vendor") {
            return Object.values(item[key]).some(
              (value) =>
                typeof value === "string" &&
                value.toLowerCase().includes(inputValue)
            );
          }
        }
        // For non-object values or keys not 'truck' or 'vendor', search directly
        return (
          typeof item[key] === "string" &&
          item[key].toLowerCase().includes(inputValue)
        );
      })
    );

    if (result.length === 0) {
      setReports([]);
    }
    setSearchInput(inputValue);
    setReports(result);
  };

  return (
    <React.Fragment>
      <Header />
      <div className="dashboard-Container">
        <div className="body-container-dashboard">
          <div className="login-heading">
            <h1 style={{ marginTop: "0px" }}>{t("Reports")}</h1>
            <h5>{t("Reports by user for the trucks")}</h5>
            <div className="input-with-search">
              <div className="search-back">
                <LuCircleChevronLeft
                  fill="none"
                  className="back-button"
                  onClick={() => navigate("/dashboard")}
                />
                <div className="input-with-search">
                  <input
                    value={searchInput}
                    placeholder={t("search")}
                    onChange={(e) => {
                      handleSearchChange(e);
                    }}
                    className="searchInput"
                  />
                  <IoIosSearch />
                </div>
              </div>
            </div>
            <div className="table-content">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div className="loading-spinner"></div>
                  <p className="logging-heading">{t("Loading")}</p>
                </div>
              ) : reports.length ? (
                <Table striped responsive className="report-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>{t("Truck Name")}</th>
                      <th>{t("Vendor Name")}</th>
                      <th>{t("Category")}</th>
                      <th>{t("Date")}</th>
                      <th>{t("Time")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reports.map((item, index) => {
                      const matchingStatement = statements.find(
                        (statement) => statement.id === item.msg_id
                      );
                      const statementValue = matchingStatement
                        ? matchingStatement.value
                        : "Not found";
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.truck.truck_name}</td>
                          <td>{item.truck.vendor.first_name}</td>
                          <td>{statementValue}</td>
                          <td>{formatDate(item.createdAt)}</td>
                          <td>{formatTime(item.createdAt)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              ) : (
                <p className="NdF">{t("No Reports Found")}</p>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </React.Fragment>
  );
}

export default Reports;
